let currentToken;

export default (store) => () => {
  let previousToken = currentToken;
  currentToken = store.getState().auth.authToken;
  if (previousToken !== currentToken) {
    if (currentToken) {
      localStorage.setItem('portalSetupAuthToken', currentToken);
    } else {
      localStorage.removeItem('portalSetupAuthToken');
    }
  }
}



// WEBPACK FOOTER //
// src/auth/auth-token.observer.js